module.exports = __webpack_public_path__ + "assets/nested.c948fb38.svg";